import { render } from "./index.vue?vue&type=template&id=bb5505b8"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=bb5505b8&lang=less"
script.render = render

export default script